import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ConvertBytesToImage } from "../Utils/Utils";
import { addToCart } from "../store/thunk/addToCart";
import { selectCartTotalAmount, selectCartProductDetails, selectUserDetails } from "../Selectors/Selector";
import { raiseError } from "../store/actions/action";


function Cart() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cartDetails = useSelector((store) => store.cart.data);
    const userDetails = useSelector(selectUserDetails);
    const cartTotalAmount = useSelector(selectCartTotalAmount);
    const cartProductDetails = useSelector(selectCartProductDetails);

    const [disabled, setDisabled] = useState(false);

    const updateCart = (item, quantity) => {
            let cartDetail = {
                UserId: userDetails.id,
                ProductId: item.productId,
                Quantity: quantity
            }
            setDisabled(true);
            dispatch(addToCart(cartDetail)).finally(setDisabled(true));

    }

    const hasOutOfStockItems = cartProductDetails?.some(item => item.stockQuantity === 0);

    const onClickProceedToCheckout = (e) => {
        e.preventDefault();
        if (hasOutOfStockItems) {
            dispatch(raiseError("Remove out-of-stock items before proceeding to checkout."));
            return;
        }
        navigate('/checkout');
    }

    const filterByQuantity = (product)=>{
            return product.quantity > 0;
    }
    return (<section className="section-padding mt-5">
        {userDetails ? <div className="container">
            <div className="row justify-content-between">
                <div className="col-md-9">
                    <div className="cart_product">
                        <div className="cart_product_heading">
                            <div className="row align-items-center">
                                <div className="col-sm-6 text-lg-left">
                                    <h4>Shopping Cart
                                        <span>( {cartDetails?.length} Item )</span>
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="cart_data">
                            {cartProductDetails && cartProductDetails.length > 0 &&
                                cartProductDetails.filter(filterByQuantity).map((item) => {
                                    let imageUrl = ConvertBytesToImage(item.image);
                                    const oos = item.stockQuantity === 0;
                                    return (<div key={item.cartId} className={`cart_item${oos ? ' opacity-50' : ''}`}>
                                        <div className="cart_item_image" style={{ position: 'relative' }}>
                                            <img src={imageUrl} alt="shop" />
                                            {oos && (
                                                <span className="badge bg-secondary position-absolute" style={{ top: 4, left: 4, fontSize: '0.65rem' }}>
                                                    Out of Stock
                                                </span>
                                            )}
                                        </div>
                                        <div className="c-item-body mt-4 mt-md-0">
                                            <div className="cart_item_title mb-2">
                                                <h4>{item.productName}</h4>
                                                {oos && <small className="text-danger">This item is no longer available</small>}
                                            </div>
                                            <div className="cart_item_price">
                                                <div className="product-price">
                                                    <span><strong>₹{item.price}</strong></span>
                                                </div>
                                                <div className="cart_product_remove">
                                                    <a href="#" onClick={() => updateCart(item, 0)} className="linkClass">
                                                        <i className="ti-trash"></i> Remove</a>
                                                </div>
                                            </div>
                                        </div>
                                        {!oos && (
                                            <div className="qty-input btn mt-4 mt-md-0" disabled={disabled}>
                                                <i className="less" onClick={() => updateCart(item, item.quantity - 1)}>-</i>
                                                <input type="text" readOnly value={item.quantity} />
                                                <i className="more" onClick={() => updateCart(item, item.quantity + 1)}>+</i>
                                            </div>
                                        )}
                                    </div>);
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 mt-lg-0 mt-6">
                    <h6 className="font-weight-bold">Deliver to</h6>
                    <div className="mb-4">
                        <select className="form-control">
                            <option value="s">Siliguri - 734001</option>
                            <option value="s" selected>Delhi - 110002</option>
                            <option value="s">Kolkata - 700027</option>
                        </select>
                    </div>
                    <div className="cart-summary">
                        <div className="cart-summary-wrap">
                            <h4>Cart Summary</h4>
                            <p>Sub Total <span>₹ {cartTotalAmount}</span></p>
                            <p>Shipping Cost <span>₹ 00.00</span></p>
                            <h2>Grand Total <span>₹ {cartTotalAmount}</span></h2>
                        </div>
                        {cartDetails?.length > 0 &&
                            <div className="cart-summary-button whiteColorClass" onClick={(e) => onClickProceedToCheckout(e)}>
                                <a href="#" className="btn btn-primary btn-rounded btn-full btn-large">Proceed to Checkout <i className="ti-arrow-right"></i> </a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div> : <div><strong>Login to see the items you added previously.</strong></div>
        }

    </section>
    );
}
export default Cart;